import { render, staticRenderFns } from "./PWidgetHeader.vue?vue&type=template&id=60cb9cd2"
import script from "./PWidgetHeader.vue?vue&type=script&lang=js"
export * from "./PWidgetHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports